<script lang="ts" setup>
import { Popup } from "vant";
import UserAvatar from "@/components/UserAvatar.vue";
import { useMateTypeText } from "@/use/common";
import GenderBadge from "@/components/MateStyle/GenderBadge.vue";
import { useMate } from "@/stores/mate";
import { storeToRefs } from "pinia";
import CheckCircleFillIcon from "@/components/icon/CheckCircleFillIcon.vue";
import CheckOutlineIcon from "@/components/icon/CheckOutlineIcon.vue";
import { ref } from "vue";
import MagicStickIcon from "@/components/icon/MagicStickIcon.vue";
import { useRouter } from "vue-router";
import MateEditIcon from "@/components/icon/MateEditIcon.vue";
import LightArrowIcon from "@/components/icon/LightArrowIcon.vue";

const props = defineProps<{
  show: boolean;
}>();
const emit = defineEmits<{
  (e: "update:show", value: boolean);
}>();

const router = useRouter();
const mateStore = useMate();
const { currentMate } = storeToRefs(mateStore);
const showCreateTraitModal = ref(false);
</script>
<template>
  <popup
    :show="show"
    :lock-scroll="true"
    position="bottom"
    round
    :close-on-click-overlay="false"
    :closeable="true"
    @update:show="emit('update:show', $event)"
    class="h-[90%]"
  >
    <div
      class="w-full h-full relative bg-base-100 flex flex-col items-center justify-between p-5"
    >
      <div
        class="w-[50%] flex-1 flex flex-col items-center justify-center gap-8"
      >
        <div class="flex flex-col items-center justify-center">
          <user-avatar class="w-full" :avatar-url="currentMate!.mediaUrl" />
          <div class="text-base font-bold mt-2 relative">
            {{ currentMate!.name }}
            <gender-badge
              :gender="currentMate!.gender"
              class="w-4 absolute -right-4 top-0"
            />
          </div>
          <div class="text-base-content/50">
            {{ useMateTypeText(currentMate!.type) }}
          </div>
        </div>
        <div class="flex items-center gap-2 relative">
          <check-outline-icon class="icon-lg text-success absolute -left-7" />
          <div class="text-base font-bold">
            {{ $t("Message.needFeatures") }}
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-2 w-[80%]">
        <button
          class="btn btn-primary rounded-3xl"
          @click="showCreateTraitModal = true"
        >
          <mate-edit-icon class="icon-lg" />
          {{ $t("Buttons.newFeature") }}
        </button>
        <button class="btn rounded-3xl" @click="emit('update:show', false)">
          <light-arrow-icon class="transform rotate-180 icon-sm" />
          {{ $t("Buttons.nextTime") }}
        </button>
      </div>
    </div>
  </popup>

  <CreateTraitPresetModal v-model:show="showCreateTraitModal" />
</template>
